import { MapPin } from "lucide-react";

export default function EmptyAddress({ setShowAddressForm }) {
  return (
    <div className="text-center py-8">
      <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <MapPin className="h-8 w-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">
        Nenhum endereço cadastrado
      </h3>
      <p className="text-gray-500 mb-4">
        Você precisa cadastrar um endereço para continuar
      </p>
      <button
        onClick={() => setShowAddressForm(true)}
        className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700">
        Cadastrar Endereço
      </button>
    </div>
  );
}
